import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Oval } from "react-loader-spinner";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import axios from "axios";
import Swal from "sweetalert2";

const WorkerCategory = () => {
  const [workerCategoryData, setWorkerCategoryData] = useState([]);
  const [loading, setLoading] = useState(true);

  const getWorkerCategory = () => {
    axios.post(API_URL.WORKER_CATEGORY_LIST, {}).then(
      (res) => {
        if (res.data.status === 1) {
          setWorkerCategoryData(res.data.data);
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        toast.error("Something went wrong..", {
          autoClose: 3000,
          
        });
      }
    );
  };

  const deleteItem = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this Worker Category",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.WORKER_CATEGORY_DELETE, { id: row.id }).then(
          (res) => {
            if (res.data.status === 1) {
              let newData = workerCategoryData.filter((r) => r.id != row.id);
              setWorkerCategoryData(newData);
              toast.success("Delete Successfully", { autoClose: 3000 });
            } else {
                toast.error(res.data.data, { autoClose: 3000 });
            }
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", { autoClose: 3000 });
          }
        );
      }
    });
  };

  useEffect(() => {
    getWorkerCategory();
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-6">
          <h1>
            Worker Category{" "}
            <small className="me-2">({workerCategoryData.length})</small>
          </h1>
        </div>
        <div className="col-6">
          <div className="d-flex align-items-center  justify-content-end">
            <Link to={"/worker-category/add"} className="btn btn-primary">
              <i className="fa fa-plus-circle me-2" aria-hidden="true"></i> Add
              Worker Category
            </Link>
          </div>
        </div>
        <div className="col-sm-12">
          <div className="card">
            <div className="card-body p-0">
              {loading ? (
                <Oval
                  height={60}
                  width={60}
                  color="#7539ff"
                  wrapperStyle={{ justifyContent: "center" }}
                  wrapperClass=""
                  visible={true}
                  ariaLabel="oval-loading"
                  secondaryColor="#7539ff"
                  strokeWidth={2}
                  strokeWidthSecondary={2}
                />
              ) : (
                <div className="table-responsive">
                  <table className="table">
                    <thead className="">
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th className="text-center" style={{ width: "200px" }}>
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {workerCategoryData.map((row, key) => {
                        return (
                          <tr key={key}>
                            <td style={{ width: "30px" }}>{key + 1}</td>
                            <td>{row.name}</td>
                            <td
                              className="d-flex justify-content-center gap-2"
                              style={{ width: "200px" }}
                            >
                              <Link
                                to={"/worker-category/edit/" + row.id}
                                className="btn btn-sm btn-secondary mr-2"
                              >
                                <i className="fa fa-edit me-1"></i> Edit
                              </Link>
                              <button
                                onClick={() => deleteItem(row)}
                                className="btn btn-sm btn-danger"
                              >
                                <i className="fa fa-trash me-1"></i> Delete
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WorkerCategory;
